import {createSelector} from 'reselect';
import authSelectors from 'src/modules/auth/authSelectors';
import PermissionChecker from 'src/modules/auth/permissionChecker';
import Permissions from 'src/security/permissions';

const selectPermissionToRead = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    new PermissionChecker(currentTenant, currentUser).match(Permissions.values.documentCategoryRead),
);

const selectPermissionToEdit = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    new PermissionChecker(currentTenant, currentUser).match(Permissions.values.documentCategoryEdit),
);

const selectPermissionToCreate = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    new PermissionChecker(currentTenant, currentUser).match(Permissions.values.documentCategoryCreate),
);

const selectPermissionToImport = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    new PermissionChecker(currentTenant, currentUser).match(Permissions.values.documentCategoryImport),
);

const selectPermissionToDestroy = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    new PermissionChecker(currentTenant, currentUser).match(Permissions.values.documentCategoryDestroy),
);

const documentCategorySelectors = {
  selectPermissionToRead,
  selectPermissionToEdit,
  selectPermissionToCreate,
  selectPermissionToDestroy,
  selectPermissionToImport,
};

export default documentCategorySelectors;
